module.exports = __webpack_public_path__ + "static/media/mute.63a097f6.svg";